module.exports = __webpack_public_path__ + "static/media/C_S01.aa301a41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREEN/C_S01.png
// module id = 100
// module chunks = 0